module.exports = __webpack_public_path__ + "img/reserved.bd7aeaac.svg";